import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentWeather: null,
  forecast: [],
  loading: false,
  error: null
};

export const weatherSlice = createSlice({
  name: 'weather',
  initialState,
  reducers: {
    fetchWeatherStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchWeatherSuccess: (state, action) => {
      state.currentWeather = action.payload.current;
      state.forecast = action.payload.forecast;
      state.loading = false;
      state.error = null;
    },
    fetchWeatherFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  },
});

export const { fetchWeatherStart, fetchWeatherSuccess, fetchWeatherFailure } = weatherSlice.actions;

// 從香港天文台獲取天氣數據
export const fetchWeatherData = () => async (dispatch) => {
  try {
    dispatch(fetchWeatherStart());
    
    // 當前天氣報告API (繁體中文)
    const currentWeatherUrl = "https://data.weather.gov.hk/weatherAPI/opendata/weather.php?dataType=rhrread&lang=tc";
    // 九天天氣預報API (繁體中文)
    const forecastUrl = "https://data.weather.gov.hk/weatherAPI/opendata/weather.php?dataType=fnd&lang=tc";
    
    // 並行請求當前天氣和預報數據
    const [currentResponse, forecastResponse] = await Promise.all([
      fetch(currentWeatherUrl),
      fetch(forecastUrl)
    ]);

    if (!currentResponse.ok || !forecastResponse.ok) {
      throw new Error('網絡請求失敗');
    }

    const currentData = await currentResponse.json();
    const forecastData = await forecastResponse.json();

    console.log('從香港天文台獲取的當前天氣數據:', currentData);
    console.log('從香港天文台獲取的預報數據:', forecastData);

    // 處理當前天氣數據
    let currentWeather = {
      temperature: currentData.temperature?.data?.[0]?.value || '無數據',
      humidity: currentData.humidity?.data?.[0]?.value || '無數據',
      icon: currentData.icon || '50',
      condition: currentData.warningMessage?.[0] || currentData.weather || '晴天',
      location: '香港',
      windSpeed: currentData.wind?.speed || '無風速數據',
      windDirection: currentData.wind?.direction || '無風向數據',
      updateTime: currentData.updateTime || new Date().toISOString()
    };

    // 處理預報數據
    let forecast = [];
    if (forecastData.weatherForecast) {
      forecast = forecastData.weatherForecast.map(day => ({
        date: day.week || day.forecastDate || '未知日期',
        high: day.forecastMaxtemp?.value || '無數據',
        low: day.forecastMintemp?.value || '無數據',
        condition: day.forecastWeather || '晴天',
        icon: day.ForecastIcon || '50',
        humidity: day.forecastMaxrh?.value && day.forecastMinrh?.value 
          ? `${day.forecastMinrh.value}-${day.forecastMaxrh.value}%` 
          : '無數據'
      }));
    }

    const weatherData = {
      current: currentWeather,
      forecast: forecast
    };
    
    dispatch(fetchWeatherSuccess(weatherData));
    return { success: true, data: weatherData };
  } catch (error) {
    console.error('獲取天氣數據錯誤:', error);
    dispatch(fetchWeatherFailure(error.message || '獲取天氣數據失敗'));
    return { success: false, error: error.message || '獲取天氣數據失敗' };
  }
};

export default weatherSlice.reducer; 